import React from 'react';
import OperatorInfoForm from 'modules/Operator/components/OperatorInfoForm';
import { useMockData } from '../state/MockDataContext';
import { SupplierFormSkeleton } from '../components/SupplierLoadingStates';

// "My Company" reuses the canonical operator company form (OperatorInfoForm)
// rather than a hand-rolled form with a hardcoded country list. That gives the
// free-supplier page the real country catalog (CountrySelectField), the same Zod
// validation, and the real save path (POST/PUT /operators). Saving invalidates
// ['loggedOperator'] — the same query the getting-started checklist + provider
// read — so company completion updates automatically.
// Item B1 (product feedback): the page HEADER stays flush-left/full-width,
// matching every other page on the platform (LiteShell's content region is
// already centered — max-w-[1600px] mx-auto — a page's own container just
// needs to not re-pin everything to its left edge). The form card stays
// centered but takes a generous width: OperatorInfoForm is a 12-col grid
// whose fields are colSpan=6 (two-per-row at md+), so a wider card gives the
// two columns real room instead of stranding a cramped 672px card in a sea
// of empty page. max-w-5xl keeps short fields (City/Phone) from stretching
// awkwardly the way an unbounded full-width card would.
export default function CompanyPage() {
  // OperatorInfoForm mounts with empty defaults and remounts (via its latched
  // formKey) once the operator record resolves, so rendering it straight away
  // flashes a blank form over the supplier's saved details. Hold the form's
  // silhouette until the fetch lands — the page header stays put throughout.
  const { loading } = useMockData();

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-xl font-bold text-slate-800 m-0">My Company</h1>
        <p className="text-sm text-slate-500 mt-1 m-0">
          Your operator information — exactly what the CBAM communication template asks for, shown
          on your public portal and every data share.
        </p>
      </div>

      {loading ? (
        <div className="w-full max-w-5xl mx-auto">
          <SupplierFormSkeleton
            sections={2}
            fieldsPerSection={6}
          />
        </div>
      ) : (
        <div className="rounded-2xl bg-white border border-slate-200 p-6 w-full max-w-5xl mx-auto">
          <OperatorInfoForm />
        </div>
      )}
    </div>
  );
}
